import { z } from 'zod';
import {
    ageRangeOrdered,
    engineRangeOrdered,
    optionalEngineInt,
    optionalInt,
    optionalUuid,
} from './planVehicleRule.schema';

const uuidList = z.array(z.string().uuid()).default([]);

export const planVehicleRuleBatchSchema = z
    .object({
        make_ids: uuidList,
        transmission_ids: uuidList,
        fuel_type_ids: uuidList,
        model_id: optionalUuid('Select a valid model'),
        derivative_id: optionalUuid('Select a valid derivative'),
        engine_min: optionalEngineInt,
        engine_max: optionalEngineInt,
        age_min: optionalInt,
        age_max: optionalInt,
        requires_4x4: z.enum(['', '4x4', 'non_4x4']).default(''),
    })
    .refine(engineRangeOrdered, { message: 'Engine max must be at least engine min', path: ['engine_max'] })
    .refine(ageRangeOrdered, { message: 'Age max must be at least age min', path: ['age_max'] })
    .refine(
        (data) => (!data.model_id && !data.derivative_id) || data.make_ids.length === 1,
        { message: 'Select a single make to set a model or derivative', path: ['model_id'] },
    );

export type PlanVehicleRuleBatchFormInput = z.input<typeof planVehicleRuleBatchSchema>;
export type PlanVehicleRuleBatchFormOutput = z.output<typeof planVehicleRuleBatchSchema>;
